(() => {
  const toggle = document.querySelector('.nav__toggle');
  const drawer = document.getElementById('NavDrawer');
  const closeBtn = document.querySelector('.drawer__close');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    toggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll');
  }

  toggle?.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    expanded ? closeDrawer() : openDrawer();
  });
  closeBtn?.addEventListener('click', closeDrawer);
  drawer?.addEventListener('click', (e) => { if (e.target === drawer) closeDrawer(); });

  document.documentElement.classList.remove('no-js');
})();
